import {
  AtlasLabel,
  AtlasLabelOptions,
  AtlasPopup,
  AtlasPopupButtons,
  AtlasPopupOptions,
} from '../../mu-atlas/interfaces/mu-atlas-types.interface';

export class MuMapLeafletPopup implements AtlasPopup {
  readonly maxWidth: string;
  readonly content: string;
  readonly minWidth: string;
  readonly autoClose: boolean;
  readonly closeButton: boolean;
  readonly className: string;
  readonly buttons?: AtlasPopupButtons[];

  constructor(options: AtlasPopupOptions) {
    this.maxWidth = options.maxWidth;
    this.content = options.content ?? '#000';
    this.minWidth = options.minWidth ?? '14px';
    this.autoClose = options.autoClose ?? true;
    this.closeButton = options.closeButton ?? true;
    this.className = options.className ?? '';
    this.buttons = options.buttons || [];
  }
}
